<template>
	<div
		class="pill-filter"
		:class="[
			orientation === 'vertical' ? '-vertical' : '-horizontal',
			multi ? '-multi' : '-single',
		]"
	>
		<button
			v-for="option in options"
			:key="option.value"
			class="pill-filter__pill"
			:class="{ 'is-selected': isSelected(option.value) }"
			type="button"
			@click="onSelect(option.value)"
		>
			{{ option.label }}
		</button>
	</div>
</template>

<script>
export default {
	name:  'PillFilter',
	props: {
		options: {
			type:     Array,
			required: true,
		},
		value: {
			type:    [Array, String, Number, null],
			default: null,
		},
		multi: {
			type:    Boolean,
			default: false,
		},
		orientation: {
			type:      String,
			default:   'horizontal', // or 'vertical'
			validator: v => ['horizontal', 'vertical'].includes(v),
		},
	},
	methods: {
		isSelected(val) {
			if (this.multi) {
				return Array.isArray(this.value) && this.value.includes(val);
			}
			return this.value === val;
		},
		onSelect(val) {
			if (this.multi) {
				const newValue = Array.isArray(this.value) ? [...this.value] : [];
				const idx = newValue.indexOf(val);
				if (idx > -1) {
					newValue.splice(idx, 1);
				} else {
					newValue.push(val);
				}
				this.$emit('input', newValue);
				this.$emit('change', newValue);
			} else {
				const newValue = this.value === val ? null : val;
				this.$emit('input', newValue);
				this.$emit('change', newValue);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.pill-filter {
	display: flex;
	align-items: flex-start;
	gap: $sp3;

	&.-vertical {
		flex-direction: column;
		gap: $sp4;
	}

	&.-horizontal {
		flex-direction: row;
	}
}

.pill-filter__pill {
	@include font-size(fs-80);
	appearance: none;
	border: 1px solid var(--color-grey-300);
	background-color: transparent;
	color: var(--color-grey-300);
	border-radius: 999px; // stylelint-disable-line
	padding: $sp3 $sp3-5;
	flex-grow: 0;
	flex-shrink: 1;
	cursor: pointer;
	transition: background-color $trans-time-fast, border-color $trans-time-fast;
	outline: none;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;

	&.is-selected {
		background-color: var(--color-hype-yellow);
		color: var(--color-text-on-hype-yellow);
		border-color: var(--color-hype-yellow);
	}
}
</style>
